import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { StyledParagraph } from '@zillow/constellation';
import styled from 'styled-components';
import { usePageProps, negativeMarginMixin } from '@zillow/zrs-cms';
import makeContentInteractive from '../../util/makeSpansInteractive.js';
import { usePlacement } from '../../components/PlacementProvider/PlacementProvider.js';

var _excluded = ["content", "textAlign", "margin"];
var CMSParagraph = /*#__PURE__*/styled(StyledParagraph).withConfig({
  componentId: "sc-1rdunrc-0"
})(["", ""], negativeMarginMixin);
var BlockParagraph = function BlockParagraph(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index;
  var content = attrs.content,
    _attrs$textAlign = attrs.textAlign,
    textAlign = _attrs$textAlign === void 0 ? 'inherit' : _attrs$textAlign,
    margin = attrs.margin,
    rest = _objectWithoutProperties(attrs, _excluded);
  var pageProps = usePageProps();
  var isPost = usePlacement() === 'post';
  if (!content) {
    return null;
  }
  var interactiveContent = makeContentInteractive(content, {
    pageProps: pageProps,
    blockAttributes: attrs
  });
  var attributes = Object.assign({
    as: 'p',
    fontType: 'body',
    marginBottom: 'sm',
    fontColor: '',
    textAlign: textAlign
  }, rest);
  return /*#__PURE__*/React.createElement(CMSParagraph, _extends({
    key: index
  }, attributes, isPost ? {
    marginBottom: 'sm'
  } : margin), interactiveContent);
};
var Paragraph = BlockParagraph;

export { Paragraph as default };
